import { ApiProperty } from "@nestjs/swagger";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Assets } from "../../open-assets/open-assets-entity";
import { AssetLocationTransaction } from "./asset-location-transaction.entity";

@Entity('asset_location_mapping')
export class AssetLocationMapping {

    @PrimaryGeneratedColumn("increment", {
        name: 'asset_location_id'
    })
    assetLocationId : number;
    
    // @Column("varchar", {
    //     name: 'asset_name'
    // })
    // assetName : string;

    @Column("int", {
        name: 'location_id'
    })
    locationId : number;
  
    // @Column("varchar", {
    //     name: 'location'
    // })
    // location : string;

    @Column("boolean", {
        name: 'is_active',
        default: true
    })
    isActive : boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    // @ApiProperty({type:[AssetLocationTransaction]})
    // @OneToMany(type => AssetLocationTransaction, assetInfo => assetInfo.assetLocationMapping, {cascade: true})
    // assetLocationDetails: AssetLocationTransaction[];
    // @ApiProperty({type:[AssetLocationTransaction]})
    @OneToMany(() => AssetLocationTransaction, (assetLocationTransaction) => assetLocationTransaction.assetLocationTransactionId, {cascade: true})
    assetLocationTransaction: AssetLocationTransaction[];


    @ManyToOne(() => Assets, (asset) => asset.assetsLocation)
    @JoinColumn({name: 'asset_id'})
    assetsId: Assets;
    
}